import { CompanyGradeExpirationCode } from '#data/CompanyGradeExpirationCode.enum';
import type { HttpMock } from '#e2e-utils/mockScenarios';
import { ControllerStatus } from '#models/ControllerStatus.enum';
import { ControllerDetails } from '#services/cve/ControllerDetails';
import { IterationStatusCode, LineOfBusiness, VettingIteration } from '#services/cve/VettingIteration';

const gradeDetails: ControllerDetails = {
  controlCode: 'CompanyGrade',
  statusCode: ControllerStatus.ACKNOWLEDGED_WITH_CHECK_SUCCESS,
  check: {
    requestDateTime: '2023-05-18T13:29:56.409Z',
    responseDateTime: '2023-05-18T13:29:56.409Z',
    requestorId: 'CVE',
    expirationDateTime: '2023-09-26T00:00:00.000Z',
    controlData: {
      companyId: '113',
      expirationCode: CompanyGradeExpirationCode.LAST_REFRESH_TOO_OLD,
      grade: {
        gradeCode: '02',
        lastRefreshDate: '2022-09-26',
      },
    },
  },
  validation: {
    requestorId: 'CVE',
    validationDateTime: '2024-09-26T00:00:00.000Z',
  },
};
const sanctionsDetails: ControllerDetails = {
  controlCode: 'EconomicSanctions',
  statusCode: ControllerStatus.ACKNOWLEDGED_WITH_ESCALATION_ACCEPTED,
  check: {
    requestorId: 'CVE',
    requestDateTime: '2024-05-21T13:29:56.409Z',
    responseDateTime: '2024-05-21T13:29:56.409Z',
    expirationDateTime: '2025-05-21T13:29:56.409Z',
    controlData: {
      escalationContact: 'test@allianz-trade.com',
      companyId: '113',
    },
  },
  escalation: {
    requestorId: 'CVE',
    requestDateTime: '2024-05-21T13:29:56.409Z',
    responseDateTime: '2024-05-21T13:29:56.409Z',
    expirationDateTime: '2025-05-21T13:29:56.409Z',
    controlData: {
      escalationResponse: {
        comment: 'Yes',
        validator: 'cve@mail.com',
      },
    },
  },
  validation: {
    requestorId: 'CVE',
    validationDateTime: '2024-05-21T13:29:56.409Z',
  },
};

export const validatedKycMocks: HttpMock[] = [
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId$',
    },
    response: {
      status: 200,
      body: {
        iterationId: 'iterationId',
        lineOfBusiness: LineOfBusiness.TCI,
        companyId: '113',
        statusCode: IterationStatusCode.VALIDATED,
        creation: {
          creationDateTime: '2024-04-19T10:05:42.156Z',
          creatorId: 'CVE',
          ownerId: 'CVE',
        },
        closure: {
          closureDateTime: '2024-04-19T10:05:42.156Z',
          requestorId: 'CVE',
        },
        controls: [gradeDetails, sanctionsDetails],
        customProperties: {},
      } satisfies VettingIteration,
    },
  },
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/EconomicSanctions$',
    },
    response: {
      status: 200,
      body: sanctionsDetails,
    },
  },
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/CompanyGrade$',
    },
    response: {
      status: 200,
      body: gradeDetails,
    },
  },
];
